

function Info() {


  return (
    <>
    <div className="sekcija p-2 mt-3">
    <div className="display-6 text-center">Kako naručiti?</div>
    <p>Vaše narudžbe izvršite minimalno 7 dana od datuma za koji Vam je potrebna torta ili poklon kutija, putem  inboxa ili na broj 061/946 - 958.<br />
Prilikom naručivanja navedite datum preuzimanja te kakvu dekoraciju bi željeli (boja, detalji). <br /><br />Možete poslati fotografije kako bi voljeli da torta izgleda, ali imajte na umu da će fotografija poslužiti kao inspiracija i da torta ne može biti identično kao sa fotografija.</p>


    <p className="bg-warning p-2 rounded text-center text-dark mt-2">Lično preuzimanje u Tuzli.</p>
</div>

<div className="sekcija p-2">
    <div className="display-6 text-center">Transport</div>
    <p>Prilikom transporta torti budite pažljivi.
Vozite polako,  polako ulazite u krivine, ne kočite naglo, ne pretičite druga vozila.<br /><br />
 
Tortu spustite na ravno mjesto (npr. ispred suvozačevog mjesta) izbjegavajte stavljati na sjedišta jer u većini slučajeva su pod blagim nagibom. 
Kada nosite tortu kutiju držite sa donje strane, nipošto sa bočnih strana jer ćete na taj način oštetiti tortu.
Vodite računa da autu rashlađeno, ako je zimski period isključite grijanje,  ljeti obavezno uključiti klimu. <br />
<p className="bg-warning p-2 rounded text-center text-dark mt-2">Tortu vozite direktno  na lokaciju (bez usputnih zaustavljanja) i odmah u frižider.</p>

Naglasite ako planirate  tortu vozit na dužu relaciju, jer možda neće biti izvodivo.
U slučaju da šaljete nekoga po tortu, naglasite koliko je bitno da se vozi pažljivo i da se prate gore navedene smjernice.</p>
</div>

<div className="sekcija p-2">
    <div className="display-6 text-center">Rok trajanja</div>
    <p><ul>
  <li>Torte i entremet monoporcije čuvajte u frižderu u zvonu za torte ili zatvorenoj kutiji.</li>
  <li>Rok trajanja voćnih torti je 3 dana od dana preuzimanja, a čokoladnih 4 dana.</li>
  <li>Keksiće poput raspucanaca čuvajte u metalnoj kutiji na sobnoj temperaturi.</li>
  <li>Linzere, sacher kekse i kuglice čuvajte u metalnim kutijama u frižideru.</li>
  <li>Rok trajanja je 5 dana od dana preuzimanja.</li>
  <li>Krofnice konzumirajte u roku od 24 sata.</li>
</ul>
</p>
</div>
  

    </>
  );
}

export default Info;
